'use client'

import { useProductTracking } from '@/hooks/use-tracking'
import { MinimalProduct } from "@/hooks/use-tracking"
import { useEffect } from 'react'

type ProductViewTrackerProps = {
  product: MinimalProduct
}

export function ProductViewTracker({ product }: ProductViewTrackerProps) {
  const { trackProductView } = useProductTracking()
  
  useEffect(() => {
    // Track product view when component mounts
    trackProductView({
      id: product.id,
      title: product.title,
      handle: product.handle,
      variants: product.variants,
      categories: product.categories,
      store_id: product.store_id,
      store_name: product.store_name
    })
  }, [product, trackProductView])
  
  // This is a tracking-only component, no UI
  return null
} 